export default '/build/c2090958.svg'